import { Component, OnInit, Input } from '@angular/core';
import { IContentElement, QuestionState } from '../models';

@Component({
  selector: 'element-render-hottext',
  templateUrl: './element-render-hottext.component.html',
  styleUrls: ['./element-render-hottext.component.scss']
})
export class ElementRenderHottextComponent implements OnInit {

  @Input() element:IContentElement;
  @Input() isLocked:boolean;
  @Input() isShowSolution:boolean;
  @Input() questionState:QuestionState;
  @Input() changeCounter:number;

  constructor() { }

  ngOnInit() {
  }

}
